import React, { useEffect } from "react";
import { Grid, Select, NumberInput } from "@mantine/core";
import {
  DATA_AR_SUBMISSION_VIA,
  DATA_AR_TRANSACTION_TYPE,
} from "../data/options";
import {
  AR_FORM_NUMBER_INPUT_PROPS,
  getArFormValues,
  setArFormField,
} from "../helpers/arFormUtils";
import OrderArFormBlock, { OrderArFormStack } from "./orderArFormBlock";

const partAFieldStyles = {
  label: {
    minHeight: 44,
    lineHeight: 1.35,
    display: "block",
    whiteSpace: "normal",
  },
};

const BilingualFieldLabel = ({ english, chinese }) => (
  <>
    {english}
    <br />
    {chinese}
  </>
);

const OrderArFormPartA = ({ form }) => {
  const arForm = getArFormValues(form);

  useEffect(() => {
    if (!form?.values?.arForm?.submissionVia) {
      setArFormField(form, "submissionVia", "Online");
    }
  }, [form, form.values?._id]);

  return (
    <OrderArFormStack>
      <OrderArFormBlock
        title="Transaction details"
        subtitle="Part A fields printed on the AR Form"
      >
        <Grid gutter="md" align="flex-start">
          <Grid.Col span={12} md={6}>
            <Select
              styles={partAFieldStyles}
              label={
                <BilingualFieldLabel
                  english="Submission via"
                  chinese="申請途徑"
                />
              }
              data={DATA_AR_SUBMISSION_VIA}
              value={arForm.submissionVia ?? null}
              onChange={(v) => setArFormField(form, "submissionVia", v)}
              searchable
              clearable
            />
          </Grid.Col>
          <Grid.Col span={12} md={6}>
            <Select
              styles={partAFieldStyles}
              label={
                <BilingualFieldLabel
                  english="Transaction type"
                  chinese="交易類型"
                />
              }
              data={DATA_AR_TRANSACTION_TYPE}
              value={arForm.transactionType ?? null}
              onChange={(v) => setArFormField(form, "transactionType", v)}
              searchable
              clearable
            />
          </Grid.Col>
          <Grid.Col span={12} md={6}>
            <NumberInput
              styles={partAFieldStyles}
              label={
                <BilingualFieldLabel
                  english="Investment Amount (HK$)"
                  chinese="投資金額 (HK$)"
                />
              }
              value={arForm.investmentAmount ?? ""}
              onChange={(v) => setArFormField(form, "investmentAmount", v)}
              precision={2}
              min={0}
              {...AR_FORM_NUMBER_INPUT_PROPS}
            />
          </Grid.Col>
          <Grid.Col span={12} md={6}>
            <Select
              styles={partAFieldStyles}
              label={
                <BilingualFieldLabel
                  english="Changes to financial situation / risk attitude?"
                  chinese="財政狀況和風險承受程度是否有任何改變?"
                />
              }
              data={[
                { value: "true", label: "Yes 是" },
                { value: "false", label: "No 否" },
              ]}
              value={
                arForm.financialSituationChanged == null
                  ? null
                  : String(arForm.financialSituationChanged)
              }
              onChange={(v) =>
                setArFormField(
                  form,
                  "financialSituationChanged",
                  v == null ? null : v === "true"
                )
              }
              clearable
            />
          </Grid.Col>
        </Grid>
      </OrderArFormBlock>
    </OrderArFormStack>
  );
};

export default OrderArFormPartA;
